if (!customElements.get('emergent-connection-help')) {
  customElements.define('emergent-connection-help', class extends HTMLElement {
    connectedCallback() {
      this.mainProduct = this.closest('product-info[id^="MainProduct-"]');
      if (this.mainProduct?.dataset.productId !== this.dataset.productId) return;
      this.trigger = this.querySelector('[data-connection-trigger]');
      this.panel = this.querySelector('[data-connection-panel]');
      this.closeButton = this.querySelector('[data-connection-close]');
      this.content = this.querySelector('[data-connection-content]');
      this.definitions = new Map([...this.querySelectorAll('template[data-connection-variant]')].map((node) => [node.dataset.connectionVariant, node]));
      if (!this.trigger || !this.panel || !this.closeButton || !this.content) return;
      this.onTrigger = () => this.isOpen ? this.close(true) : this.openPanel();
      this.onClose = () => this.close(true);
      this.onProductChange = this.onProductChange.bind(this);
      this.onOutside = (event) => { if (!this.contains(event.target)) this.close(false); };
      this.onEscape = (event) => {
        if (event.key === 'Escape' && this.isOpen) {
          event.preventDefault();
          event.stopPropagation();
          this.close(true);
        }
      };
      this.onFocusOut = (event) => { if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(false); };
      this.reposition = this.reposition.bind(this);
      this.trigger.addEventListener('click', this.onTrigger);
      this.closeButton.addEventListener('click', this.onClose);
      this.mainProduct.addEventListener('change', this.onProductChange);
      this.addEventListener('focusout', this.onFocusOut);
      const input = this.mainProduct.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      if (input) this.showDefinition(input.value);
    }

    disconnectedCallback() {
      this.close(false);
      this.trigger?.removeEventListener('click', this.onTrigger);
      this.closeButton?.removeEventListener('click', this.onClose);
      this.mainProduct?.removeEventListener('change', this.onProductChange);
      this.removeEventListener('focusout', this.onFocusOut);
    }

    onProductChange(event) {
      const input = event.target;
      if (!input.matches?.('form[data-type="add-to-cart-form"] input[name="id"]') || input.closest('product-info[id^="MainProduct-"]') !== this.mainProduct) return;
      this.showDefinition(input.value);
    }

    showDefinition(variantId) {
      this.close(false);
      const template = this.definitions.get(String(variantId));
      this.hidden = !template;
      this.content.replaceChildren(...(template ? [template.content.cloneNode(true)] : []));
      const label = template?.dataset.connectionLabel || '';
      this.trigger.textContent = (this.dataset.triggerLabel || '[connection]').replace('[connection]', label);
    }

    openPanel() {
      if (this.hidden || !this.panel) return;
      this.isOpen = true;
      this.panel.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.reposition();
      document.addEventListener('pointerdown', this.onOutside, true);
      document.addEventListener('keydown', this.onEscape);
      window.addEventListener('resize', this.reposition);
      window.addEventListener('scroll', this.reposition, true);
      this.closeButton.focus({preventScroll:true});
    }

    close(restoreFocus) {
      if (!this.panel) return;
      const wasOpen = this.isOpen;
      this.isOpen = false;
      this.panel.hidden = true;
      this.trigger?.setAttribute('aria-expanded', 'false');
      document.removeEventListener('pointerdown', this.onOutside, true);
      document.removeEventListener('keydown', this.onEscape);
      window.removeEventListener('resize', this.reposition);
      window.removeEventListener('scroll', this.reposition, true);
      if (wasOpen && restoreFocus) this.trigger?.focus({preventScroll:true});
    }

    reposition() {
      if (!this.isOpen) return;
      const gap = 8;
      const edge = 16;
      const anchor = this.trigger.getBoundingClientRect();
      if (anchor.bottom < 0 || anchor.top > window.innerHeight) {
        this.close(false);
        return;
      }
      const below = window.innerHeight - anchor.bottom - gap - edge;
      const above = anchor.top - gap - edge;
      const useBelow = below >= 240 || below >= above;
      this.panel.style.maxHeight = `${Math.max(80, useBelow ? below : above)}px`;
      const bounds = this.panel.getBoundingClientRect();
      const left = Math.max(edge, Math.min(anchor.left, window.innerWidth - bounds.width - edge));
      const top = useBelow ? anchor.bottom + gap : Math.max(edge, anchor.top - bounds.height - gap);
      this.panel.style.left = `${left}px`;
      this.panel.style.top = `${Math.max(edge, top)}px`;
    }
  });
}
